var wo;
  
setTimeout(function(){
  $('#bLogoAnim').addClass('s1')
  setTimeout(function(){
    $('#bLogoAnim').addClass('s2')
    setTimeout(function(){
      $('#bLogoAnim').addClass('s3')
      setTimeout(function(){
        $('#bLogoAnim').addClass('s4')
        
        setTimeout(function(){
          wo = new WorldAnimator()

          setTimeout(function(){
            $('#bLogoAnim').addClass('noooverflow');
            
          }, 100)
          setTimeout(function(){

            $("#bLogoAnim").on('mouseenter', function(){
              wo.shake()
            })

            // $("#bLogoAnim").sparkleHover({
            //   colors : ['#e2bab3'],
            //   num_sprites: 5,
            //   lifespan: 2000,
            //   radius: 100,
            //   sprite_size: 2,
            //   shape: 'circle',
            //   gravity: 'true',
            //   loop: 300,
            //   container: $('#bLogoAnim .mask')
            // })
          }, 1500)
        }, 300)
      }, 300)
    }, 300)
  }, 300)

}, 500)
